import { useEffect, useRef } from "react";

import { Ds } from "@accurx/design";
import { PathwayTemplate } from "@accurx/message-templates";
import { useCompose } from "domains/message-component/context";

import {
    MessageBody,
    MessageContainer,
    MessageHeader,
} from "./PathwaysTemplatePreview.styles";
import { StyledHyphenatedText, StyledWrapper } from "./TemplatePreview.styles";

type PathwaysTemplatePreviewProps = { template: PathwayTemplate };

export const PathwaysTemplatePreview = ({
    template,
}: PathwaysTemplatePreviewProps) => {
    /**
     * Screenreader lose focus and revert back to the top of window when navigating to preview.
     * This ref moves focus back to the component and reads out the title.
     */
    const sectionRef = useRef<HTMLDivElement>(null);

    const { state } = useCompose();

    useEffect(() => {
        if (sectionRef.current) {
            sectionRef.current.focus();
        }
    }, []);

    return (
        <section
            aria-label={`${template.title} preview`}
            tabIndex={-1}
            ref={sectionRef}
        >
            <StyledWrapper>
                <StyledHyphenatedText
                    size="medium"
                    weight="bold"
                    forwardedAs="h2"
                >
                    {template.title}
                </StyledHyphenatedText>

                {template.messages.map((message, index) => (
                    <MessageContainer key={index}>
                        <MessageHeader>
                            <Ds.Text weight="bold">
                                {message.title} ({index + 1}/
                                {template.messages.length})
                            </Ds.Text>
                        </MessageHeader>
                        <MessageBody>
                            <StyledHyphenatedText size="small">
                                {state.originalGreeting}
                            </StyledHyphenatedText>
                            <StyledHyphenatedText size="small">
                                {message.body}
                            </StyledHyphenatedText>
                            <StyledHyphenatedText size="small">
                                {state.originalSignature}
                            </StyledHyphenatedText>
                        </MessageBody>
                    </MessageContainer>
                ))}
            </StyledWrapper>
        </section>
    );
};
